import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncProsemirrorRTE = Loadable({
  loader: () => import( /* webpackChunkName: "prosemirror-rte" */'./ProsemirrorRichTextEditor')
});
export default AsyncProsemirrorRTE;